// models
import { type BaseSearchRequest, type ReqCompanyDetail } from 'modules';

/**
 * Company 관련 Query Keys
 *
 * @description
 * Company 설정 관련 query-key들을 관리합니다.
 */
export const companyKeys = {
  /** ALL */
  COMPANY_ALL: ['company'],

  /** 업체 이름 조회 */
  GET_COMPANY_NAMES: (params: BaseSearchRequest) => [
    'company',
    'getCompanyNames',
    JSON.stringify(params)
  ],

  /** 업체 상세 조회 */
  GET_COMPANY_DETAIL: (params?: ReqCompanyDetail) => [
    'company',
    'getCompanyDetail',
    JSON.stringify(params)
  ],

  /** 업체 수정 */
  UPDATE_COMPANY: () => ['company', 'updateCompany']
};
